// extracted by css-extract-rspack-plugin
export default {"segmentGroups":"segmentGroups-UoedBO","groupRow":"groupRow-or0dx3","segmentChipLayout":"segmentChipLayout-bNN4JK","addSegmentIcon":"addSegmentIcon-xMDaa0"};